import React from 'react';
import Timestamp from '../../../Timestamp';
import UserAvatar from '../../../User/Avatar';
import BasicUserName from '../../../User/BasicUserName';
import UserLink from '../../../User/Link';
import s from './FooterPanel.scss';
export var FOOTER_PANEL_HEIGHT = parseInt(s['footer-panel-height'], 10);
var FooterPanel = function (_a) {
    var deviation = _a.deviation, _b = _a.withAuthorLink, withAuthorLink = _b === void 0 ? true : _b;
    var author = deviation.author && (React.createElement(React.Fragment, null,
        React.createElement(UserAvatar, { user: deviation.author, size: 24, className: s['avatar'], withLink: false }),
        React.createElement("span", { className: s['username'] },
            React.createElement(BasicUserName, { user: deviation.author }))));
    return (React.createElement("div", { className: s['root'] },
        deviation.author &&
            (withAuthorLink ? (React.createElement(UserLink, { user: deviation.author, className: s['author'] }, author)) : (React.createElement("span", { className: s['author'] }, author))),
        React.createElement(Timestamp, { timestamp: deviation.publishedTime, className: s['timestamp'] })));
};
FooterPanel.displayName = 'FooterPanel';
export default FooterPanel;
//# sourceMappingURL=FooterPanel.js.map